import React from "react";
import { BodyItemContainer } from "./index.styled";
import { getTypeIcon } from "../utils/iconHelpers";

interface CardBodyItemProps {
  title: string;
  value: number;
  type: string;
}

const CardBodyItem: React.FC<CardBodyItemProps> = ({ title, value, type }) => {
  return (
    <BodyItemContainer>
      <div className="card-body-item-text">
        <div className="card-body-item-title">{title}</div>
        <div className="card-body-item-value">{value}</div>
      </div>
      <div className="card-body-item-type">
        {getTypeIcon(type) && (
          <img
            src={getTypeIcon(type)!}
            alt={type}
            className="type-icon"
          />
        )}
      </div>
    </BodyItemContainer>
  );
};

export default CardBodyItem;
